import { styled } from '@mui/material';
import { TOOLBAR_HEIGHT } from 'theme';
import { BOTTOM_NAV_HEIGHT } from '../../constants';

const Root = styled('div')({
  position: 'relative',
  height: '100%',
});

const TopContainer = styled('div')({
  flexGrow: 1,
  maxHeight: `calc(100vh - (${BOTTOM_NAV_HEIGHT}px) + ${TOOLBAR_HEIGHT}px)`,
});

export { Root, TopContainer };
